<template>
    <admin-layout>
        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3 d-flex flex-column flex-md-row">
                    <h1 class="mr-3 mb-3">Message Templates</h1>
                    <div class="actions ml-auto">
                        <inertia-link :href="route('message-template.create', {...global_url_params})"
                                      class="btn btn-primary d-flex align-items-center">
                            <img src="/images/icons/plus-circle-solid-light.svg" class="mr-1" alt="">
                            Create new Template
                        </inertia-link>
                    </div>
                </div>
            </template>

            <hr>

            <div class="table-responsive">
                <table class="templates table table-hover">
                    <thead>
                    <tr>
                        <th width="300">Template Code</th>
                        <th>Title</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(template, index) in templates.data">
                        <td>
                            {{ template.type }}.{{ template.name }}
                            <div class="actions">
                                <inertia-link :href="route('message-template.edit', {message_template: template, ...global_url_params})"
                                              class="btn btn-link btn-sm px-1">Edit</inertia-link>
                                <button @click="deleteTemplate(template)"
                                        class="btn btn-link btn-sm text-danger px-1">Delete</button>
                            </div>
                        </td>
                        <td>{{ template.title }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import API from "@/API";
export default {
    name: "Index",
    components: {AppContentPane, AdminLayout},
    props: ['templates'],

    methods: {
        deleteTemplate(message_template){
            if( !confirm('Are you sure to delete this template?') ) return;
            this.$inertia.delete(route('message-template.destroy', {message_template, ...this.global_url_params}));
        }
    },

    mounted() {
        this.setTitle( 'Message Templates' );
    }

}
</script>

<style lang="scss" scoped>
.templates{
    .actions{
        opacity: 0;
    }
    tr{
        &:hover{
            .actions{
                opacity: 1;
            }
        }
    }
}

</style>
